<script setup lang="ts">
import type { CustomWindow } from '~/types/custom-window';

onActivated(async () => {
  if (!user.value?.userInfo?.customerId) {
    getReferralId();
  }
});

const { variant } = defineProps<{
  variant: 'soft' | 'solid' | 'ghost';
}>();

const { $fetchAPI } = useNuxtApp();
const { user } = useOidcAuth();

const quantity = ref(1);
const referralId = ref<string | null>(null);

const proceedToCheckout = async () => {
  const sessionUrl = await $fetchAPI('/api/stripe/createCheckoutSession', {
    method: 'POST',
    body: { quantity: quantity.value, referralId: referralId.value },
  });

  navigateTo(sessionUrl, { external: true });
};

const getReferralId = () => {
  const customWindow = window as unknown as CustomWindow;

  if (customWindow.rewardful) {
    customWindow.rewardful('ready', () => {
      if (customWindow.Rewardful?.referral) {
        referralId.value = customWindow.Rewardful.referral;
      }
    });
  }
};
</script>
<template>
  <UButton
    label="Buy credits"
    :variant="variant"
    color="primary"
    :icon="variant != 'ghost' ? 'i-lucide-wallet' :''"
    size="lg"
    @click="proceedToCheckout()"
  />
</template>
<style></style>
